module.exports = __webpack_public_path__ + "static/media/Share.9366cb86.svg";